import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  "/": "Conecta Vicência",
  "/home": "Página Inicial - Conecta Vicência",
  "/solicitacoes/PENDENTE": "Solicitações - Conecta Vicência",
  "/ubs/cadastrar": "Cadastrar UBS - Conecta Vicência",
  "/ubs/listar": "Lista de UBS - Conecta Vicência",
  "/estatisticas": "Estatísticas - Conecta Vicência",
  "/login": "Login - Conecta Vicência",
  "/reset-password": "Redefinir Senha - Conecta Vicência",
  "/cadastrar-usuario": "Cadastrar Usuário - Conecta Vicência",
  "/upload-documents/:token": "Upload de Documentos - Conecta Vicência",
  "/home_psf": "Página Inicial PSF - Conecta Vicência",
  "/servicos/gerenciar/EXAME": "Gerenciar Tipos de Exame - Conecta Vicência",
  "/servicos/gerenciar/CONSULTA": "Gerenciar Tipos de Consulta - Conecta Vicência",
  "/servicos/gerenciar/TRANSPORTE": "Gerenciar Tipos de Transporte - Conecta Vicência",
  "/atualizar-cadastro": "Atualizar Cadastro - Conecta Vicência",
  "/auditoria": "Auditoria - Conecta Vicência",
};

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = TITLES[location.pathname] || "Conecta Vicência";
  }, [location.pathname]);
};

export default usePageTitle;
